export default function CheckmarkIcon({ className, variation }: { className?: string; variation?: number }) {
  if (variation === 4) {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
          d="M4.16602 10.0007L8.33268 14.1673L16.666 5.83398"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  if (variation === 3) {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
          d="M18.0002 1.60787C19.8102 2.6529 21.3158 4.1525 22.3681 5.95823C23.4203 7.76396 23.9827 9.81319 23.9996 11.9031C24.0165 13.993 23.4873 16.051 22.4643 17.8735C21.4413 19.696 19.9601 21.2197 18.1673 22.2938C16.3745 23.368 14.3322 23.9553 12.2427 23.9975C10.1531 24.0398 8.08876 23.5357 6.25394 22.535C4.41913 21.5342 2.87748 20.0717 1.78162 18.2921C0.685763 16.5125 0.0736921 14.4775 0.00600021 12.3887L0 11.9999L0.00600021 11.6111C0.0732047 9.53866 0.676266 7.51902 1.75639 5.74906C2.83651 3.9791 4.35684 2.51921 6.16915 1.51173C7.98145 0.504246 10.0239 -0.0164529 12.0974 0.000396295C14.1708 0.0172455 16.2045 0.571068 18.0002 1.60787ZM16.4486 8.75147C16.242 8.54486 15.967 8.42074 15.6754 8.4024C15.3838 8.38407 15.0955 8.47277 14.8646 8.65187L14.7518 8.75147L10.8001 12.7019L9.24851 11.1515L9.13571 11.0519C8.90481 10.8729 8.61655 10.7843 8.32499 10.8027C8.03342 10.8211 7.75858 10.9452 7.55201 11.1518C7.34543 11.3584 7.22131 11.6332 7.20291 11.9248C7.18452 12.2163 7.27312 12.5046 7.45209 12.7355L7.55169 12.8483L9.95172 15.2483L10.0645 15.3479C10.275 15.5111 10.5338 15.5998 10.8001 15.5998C11.0665 15.5998 11.3253 15.5111 11.5357 15.3479L11.6485 15.2483L16.4486 10.4483L16.5482 10.3355C16.7273 10.1046 16.816 9.81628 16.7977 9.52465C16.7793 9.23302 16.6552 8.9581 16.4486 8.75147Z"
          fill="#3DAE44"
        />
      </svg>
    );
  }
  if (variation === 2) {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none">
        <path
          d="M3.33398 7.9974L6.66732 11.3307L13.334 4.66406"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none">
      <g clip-path="url(#clip0_41431_13943)">
        <path
          d="M6 0C2.69173 0 0 2.69173 0 6C0 9.30827 2.69173 12 6 12C9.30827 12 12 9.30827 12 6C12 2.69173 9.30827 0 6 0ZM9.35338 4.42105L5.5188 8.22556C5.29323 8.45113 4.93233 8.46617 4.69173 8.2406L2.66165 6.39098C2.42105 6.16541 2.40602 5.78947 2.61654 5.54887C2.84211 5.30827 3.21805 5.29323 3.45865 5.5188L5.06767 6.99248L8.49624 3.56391C8.73684 3.32331 9.11278 3.32331 9.35338 3.56391C9.59399 3.80451 9.59399 4.18045 9.35338 4.42105Z"
          fill="#3DAE44"
        />
      </g>
      <defs>
        <clipPath id="clip0_41431_13943">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
